import request from "src/utils/request";
import getOverview from "src/scenes/dashboard/mock-data/overview";
import useApi from "./use-api";

const useNotionSetupApi = () => {
    const requestHandler = (abortController) => {
        return request(`/api/notion/setup`, { abortController });
    };

    return useApi(
        () => getOverview(),
        ({ abortController }) => requestHandler(abortController),
        undefined,
        `/api/notion/setup`
    );
};

export default useNotionSetupApi;
